import { VueApp } from '@/setup/CreateApp'

import Toast, { PluginOptions, POSITION } from "vue-toastification";
import 'vue-toastification/dist/index.css'

const options: PluginOptions = {
    position: POSITION.TOP_CENTER,
    maxToasts: 0,  // Deshabilita todos los toasts
    newestOnTop: false
}

VueApp.use(Toast, options);